'use client';

import { StatisticsContent, StatisticsForm } from '@/components/authority/statistics';
import { AppealStat, StatisticsQueryParams } from '@/lib/types';
import { AUTHORITY_CODE } from '@/lib/utils';
import { Breadcrumb, Section } from '@/ui';
import { Content } from '@/widgets';
import { Container } from '@mantine/core';
import dayjs from 'dayjs';
import { useState } from 'react';
import useSWR from 'swr';

type Data = {
  breadcrumb: string;
  menu_id: number;
  menu_title: string;
  menu_item_id: number;
  data: AppealStat;
};

export default function Statistics() {
  const [params, setParams] = useState<StatisticsQueryParams>({
    end_date: dayjs(new Date()).format('YYYY-MM-DD'),
    start_date: undefined,
    applicant_type: undefined,
  });

  const { data: statData, isLoading: isStatLoading } = useSWR<Data>([
    '/authorities/request/get-request-stat',
    { body: params, method: 'POST' },
  ]);

  const breadcrumbItems = [
    { title: statData?.breadcrumb, href: `/${AUTHORITY_CODE}/general-menu/${statData?.menu_id}` },
    { title: statData?.menu_title, isCurrent: true },
  ];

  return (
    <Container>
      <Section
        rightMenu={{
          isActive: true,
          id: statData?.menu_id,
          activeItem: { id: statData?.menu_item_id as number },
        }}
      >
        <Content>
          <Content.Header>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{statData?.menu_title}</Content.Title>
          <Content.Body className="flex flex-col gap-8">
            <StatisticsForm params={params} setParams={setParams} />
            <StatisticsContent statistics={statData as Data} isLoading={isStatLoading} />
          </Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
